<template>
    <div id="insurance_policy_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar" v-if="displayMenu">
            <div class="right-asset-tab-list">
                <ul id="tabActive" class="activetabs">
                    <li class="active"> <a href="javascript:void(0)" v-on:click="activetab = 1"> Agreement Detail </a> </li>
                    <li> <a href="javascript:void(0)" v-on:click="activetab = 2"> Billed </a> </li>
                    <li id="rentalRates"> <a href="javascript:void(0)" v-on:click="activetab = 3"> Rental Rates </a> </li>
                    <li> <a href="javascript:void(0)" v-on:click="activetab = 4"> Insurance Charges </a> </li>
                    <li> <a href="javascript:void(0)" v-on:click="activetab = 5"> Insurance Policy Details </a> </li>
                    <!-- <li> <a href="javascript:void(0)" v-on:click="fetchBilling()"> Billing Records </a> </li> -->
                    <li> <a href="javascript:void(0)" v-on:click="getActivityLog()"> Activity Log </a> </li>
                    <li> <a href="javascript:void(0)" v-on:click="activetab = 9"> Miscellaneous Charges </a> </li>
                    <li> <a href="javascript:void(0)" v-on:click="activetab = 8"> Discounted Days </a> </li>
                    <li v-if="rentalTypeCode == 'OSR'"> <a href="javascript:void(0)" v-on:click="activetab = 10"> OSR Voucher </a> </li>
                    <li id="credit-request"> <a href="javascript:void(0)" v-on:click="getCustomerCreditRequest()"> Request Status </a> </li>
                </ul>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name">
                    <div class="page-title adjustTitleWidth"> #{{ code }}</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <button v-if="rentalTypeCode == 'OSR'" type="submit"  class="btn btn-secondary" v-on:click.prevent="addVendorInvoice()"><i class="fp-plus"></i>Add Vendor Invoice</button>
                        <button type="submit" id="downloadAgreementBtn" v-on:click="downloadPdf()" class="btn btn-secondary"><i class="fp-export"></i> Download PDF</button>
                        <button v-if="closed == 1 && (rentalTypeCode != 'COMP' && rentalTypeCode != 'TRANSF') && status != 'void' " type="submit" class="btn btn-primary" v-on:click.prevent="openModal('last')">Post Invoice</button>
                        <button v-if="closed == 0 && status == 'active' && (rentalTypeCode != 'COMP' && rentalTypeCode != 'TRANSF') && billing_frequency == 'monthly' && isBilled == 'no'" type="submit" class="btn btn-primary" v-on:click.prevent="openModal('first')">Post Invoice</button>
                        <button v-if="closed == 0 && status == 'active'" type="submit"  class="btn btn-secondary" v-on:click.prevent="updateRentalAgreement('return')">Return Unit</button>
                        <button type="submit" class="btn btn-secondary" v-if="status == 'active' && (rentalTypeCode != 'COMP' && rentalTypeCode != 'TRANSF') && isBilled == 'yes'" v-on:click.prevent="rebillVariable">Rebill</button>
                        <button v-if="closed == 0 && status == 'pending'" type="submit" class="btn btn-primary" v-on:click.prevent="checkTriggers('check_date')">Process</button>
                        <button v-if="closed == 0 && status == 'active' && isBilled == 'no'" type="submit" class="btn btn-primary" v-on:click.prevent="processAgreement('unprocess','')">UnProcess</button>
                        <button v-if="closed == 0 && status == 'active' && closed == 0" type="submit" class="btn btn-primary" v-on:click.prevent="extendAgreement()">Extend</button>
                        <button v-if="((closed === 0 && status === 'pending') || (canEditAfterClose && closed === 1 && status != 'billed')) && activetab === 1" type="submit" class="btn btn-primary" v-on:click.prevent="updateRentalAgreement('edit')">
                            <i class="fp-edit-icon"> </i> Edit
                        </button>
                        <button type="submit" class="btn btn-secondary" v-if="discountDayGen == 'no'" v-on:click.prevent="discountedDayGenerate()">Generate Discounted Days</button>
                        <button type="submit" v-if="closed != 0" class="btn btn-secondary" v-on:click.prevent="sendForApproval('deposit')">Request Deposit Refund</button>
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="goPreviousPath"><i class="fp-back"> </i> Back</button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div id="rental_agreement_detail" class="admin-page-content rental-agreement-view list-view">
                        <section class="internal-container border-top-table-fl">
                            <template v-if="activetab == 1">
                                <div class="list-sections">
                                    <div class="form-row section-divider">
                                        <div class="col-md-6">
                                            <div class="row form-group">
                                                <label class="col">Reservation Ref#: </label>
                                                <span class="col"><a class="color-blue" href="javascript:void(0)" v-on:click="viewBooking(bookingId)"> {{resRefNo}} </a></span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col">Customer:</label>
                                                <span class="col">
                                                    <a href="javascript:void(0)" title="View customer" class="color-blue" v-on:click.prevent="viewModulelink('/dealer/view/',customerId,'')">
                                                        {{ titleCase(customerName) }}
                                                    </a>
                                                </span>
                                            </div>
                                            <div class="row form-group" v-if="showFields">
                                                <label class="col" v-if="consolidated != ''">Consolidated:</label>
                                                <span class="col"> {{ titleCase(consolidated) }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col" v-if="notes != ''">Notes:</label>
                                                <span class="col"> {{ notes }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col">Is National Lease:</label>
                                                <span class="col" v-if="is_national_lease == 1">Yes </span>
                                                <span class="col" v-else>No</span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col" v-if="customerInsured != ''">Customer Purchasing Insurance:</label>
                                                <span class="col"> {{ customerInsured }} </span>
                                            </div>
                                            <template v-if="customerInsured != '' && customerInsured.toLowerCase() == 'yes'">
                                                <div class="row form-group">
                                                    <label class="col" v-if="physicalFromDate != ''">Physical From Date:</label>
                                                    <span class="col"> {{ physicalFromDate }} </span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col" v-if="liabilityFromDate != ''">Liability From Date:</label>
                                                    <span class="col"> {{ liabilityFromDate }} </span>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="row form-group">
                                                <label class="col">PO:</label>
                                                <span class="col">  {{ poNo }}</span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col">Contract Type:</label>
                                                <span class="col">  {{ rentalTypeCode }} | {{ rentalTypeName }}</span>
                                            </div>
                                            <div class="row form-group" v-if="showFields">
                                                <label class="col" v-if="isSubstitute != ''">Is Substitute:</label>
                                                <span class="col"> {{ isSubstitute }} </span>
                                            </div>
                                            <div class="row form-group" v-if="showFields && isSubstitute != '' && isSubstitute.toLowerCase() == 'yes' && contractAsset != ''">
                                                <label class="col">Contract Asset:</label>
                                                <span class="col"> {{ contractAsset }} </span>
                                            </div>
                                            <div class="row form-group" v-if="showFields && isSubstitute != '' && isSubstitute.toLowerCase() == 'yes' && sub_agreement != ''">
                                                <label class="col">Substitute Agreement:</label>
                                                <span class="col"> {{ sub_agreement }} </span>
                                            </div>
                                            <div class="row form-group" v-if="showFields && isSubstitute != '' && isSubstitute.toLowerCase() == 'yes'">
                                                <label class="col">Sub Unit:</label>
                                                <span class="col"> {{ sub_unit }} </span>
                                            </div>
                                            <template v-if="customerInsured != '' && customerInsured.toLowerCase() == 'yes'">
                                                <div class="row form-group">
                                                    <label class="col" v-if="physicalToDate != ''">Physical To Date:</label>
                                                    <span class="col"> {{ physicalToDate }} </span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col" v-if="liabilityToDate != ''">Liability To Date:</label>
                                                    <span class="col"> {{ liabilityToDate }} </span>
                                                </div>
                                            </template>
                                            <div class="row form-group">
                                                <label class="col">Status:</label>
                                                <span class="col"> {{ titleCase(status) }} </span>
                                            </div>
                                            <div class="row form-group" v-if="status == 'void'">
                                                <label class="col">Void Reason:</label>
                                                <span class="col"> {{ titleCase(void_reason) }} </span>
                                            </div>
                                            <div class="row form-group" v-if="custCreditApprReqStatus != ''">
                                                <label class="col">Credit Override Req. Status:</label>
                                                <span class="col"><span :class="bedgeClass">{{ titleCase(custCreditApprReqStatus) }}</span></span>
                                            </div>
                                            <div class="row form-group" v-if="closed > 0">
                                                <label class="col">Fuel Required:</label>
                                                <span class="col" v-if="fuel_required == 1">Yes </span>
                                                <span class="col" v-else>No</span>
                                            </div>
                                            <div class="row form-group" v-if="closed > 0">
                                                <label class="col">Unit Damage on Return:</label>
                                                <span class="col" v-if="damage_return == 1">Yes </span>
                                                <span class="col" v-else>No</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="list-sections">
                                    <h5 class="ml-2">Reservation Period</h5>
                                    <div class="form-row section-divider">
                                        <div class="col-sm-6">
                                            <div class="row form-group">
                                                <label class="col"> Due Out Time: </label>
                                                <span class="col"> {{ dueOutDateTime }} </span>
                                            </div>

                                            <div class="row form-group">
                                                <label class="col"> Due In Time: </label>
                                                <span class="col"> {{ dueInDateTime }} </span>
                                            </div>

                                            <div class="row form-group">
                                                <label class="col"> Due Out Location: </label>
                                                <span class="col"> {{ dueOutLocation }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Due In Location: </label>
                                                <span class="col"> {{ dueInLocation }} </span>
                                            </div>

                                            <div class="row form-group">
                                                <label class="col"> Planned In Time: </label>
                                                <span class="col"> {{ plannedInDateTime }} </span>
                                            </div>
                                        </div>
                                        <!-- <div class="col-sm-4">
                                            <div class="row form-group">
                                                <label class="col"> Charge From Time :</label>
                                                <span class="col"> {{ chargeFromDateTime }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Charge To Time :</label>
                                                <span class="col"> {{ chargeToDateTime }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Charge From Location :</label>
                                                <span class="col"> {{ chargeFromLocation }} </span>
                                            </div>
                                        </div> -->
                                        <div class="col-sm-6">
                                            <div class="row form-group">
                                                <label class="col"> Actual From Time: </label>
                                                <span class="col"> {{ actualOutDateTime }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Actual To Time: </label>
                                                <span class="col"> {{ actualInDateTime }} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="list-sections">
                                    <h5 class="ml-2">Unit Details</h5>
                                    <div class="form-row section-divider">
                                        <div class="col-md-6">
                                            <div class="row form-group">
                                                <label class="col"> Unit No.: </label>
                                                <span class="col">
                                                    <a href="javascript:void(0)" title="View asset" class="color-blue" v-on:click.prevent="viewModulelink('/asset/view/',vehicle_id,'')">
                                                        {{ unitNo }} | {{ unitName }}
                                                    </a>
                                                </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Asset Type: </label>
                                                <span class="col"> {{ unitTypeCode }} | {{ unitTypeName }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Requested Asset Type: </label>
                                                <span class="col"> {{ reqAssetType }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> GVW: </label>
                                                <span class="col"> {{ unitGvw }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Reading Out Miles: </label>
                                                <span class="col">
                                                    <template v-for="(readingItems , readingKey) in readingOut">
                                                        <div :key="readingKey">
                                                            <div> Section : {{ readingItems.section }} </div>
                                                            <div> Reading Out : {{ readingItems.reading_out }} </div>
                                                            <div> Reading Out Date: {{ readingItems.reading_out_date }} </div>
                                                        </div>
                                                    </template>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <template v-if="rentalTypeCode == 'OSR'">
                                            <div class="row form-group">
                                                <label class="col"> Vendor: </label>
                                                <span class="col"> {{ vendorCode }} | {{ vendorName }}</span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Vendor PO#: </label>
                                                <span class="col">
                                                    <a href="javascript:void(0)" title="View Vendor PO" class="color-blue" v-on:click.prevent="viewModulelink('/vendor-purchase-order/view/',vehicle_id,'?fromUrl='+pagePath)">
                                                        {{ vendorPoNo }}
                                                    </a>
                                                </span>
                                            </div>
                                            </template>
                                            <div class="row form-group">
                                                <label class="col"> State: </label>
                                                <span class="col"> {{ state }} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Reading In Miles: </label>
                                                <span class="col">
                                                    <template v-for="(readingItems , readingKey) in readingIn">
                                                        <div :key="readingKey">
                                                            <div> Section : {{ readingItems.section }} </div>
                                                            <div> Reading In : {{ readingItems.reading_in }} </div>
                                                            <div> Reading In Date: {{ readingItems.reading_in_date }} </div>
                                                        </div>
                                                    </template>
                                                </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Reason: </label>
                                                <span class="col"> {{ reason }} </span>
                                            </div>
                                            <!--template v-if="rentalTypeCode == 'OSR'">
                                              <div class="row form-group">
                                                  <label class="col"> Vendor: </label>
                                                  <span class="col"> {{ vendorCode }} | {{ vendorName }} </span>
                                              </div>
                                              <div class="row form-group">
                                                  <label class="col"> Vendor Invoice Number: </label>
                                                  <span class="col"> {{ vendorInvoiceNumber }} </span>
                                              </div>
                                              <div class="row form-group">
                                                  <label class="col"> Vendor Invoice Voucher Number: </label>
                                                  <span class="col"> {{ vendorInvoiceVoucherNumber }} </span>
                                              </div>
                                              <div class="row form-group">
                                                  <label class="col"> Vendor Invoice Bill Date: </label>
                                                  <span class="col"> {{ vendorInvoiceBillDate }} </span>
                                              </div>
                                              <div class="row form-group">
                                                  <label class="col"> Vendor Invoice Due Date: </label>
                                                  <span class="col"> {{ due_date }} </span>
                                              </div>
                                              <div class="row form-group">
                                                  <label class="col"> Vendor Invoice Amount: </label>
                                                  <span class="col"> {{ invoiceNetAmount }} </span>
                                              </div>
                                            </template-->
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="activetab == 2">
                                <div class="list-sections">
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Invoice No.</th>
                                                    <th>Unit No.</th>
                                                    <th>Section/Charge</th>
                                                    <th class="text-right">Billed Days</th>
                                                    <th class="text-right">Billing Rate</th>
                                                    <th>&nbsp;</th>
                                                    <th class="text-right">Billed Amount</th>
                                                    <th class="text-right">Billed Date</th>
                                                    <th>Selected</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="billingRecordsArr && billingRecordsArr.length > 0">
                                                    <template v-for="(record, index) in billingRecordsArr">
                                                        <tr v-bind:key="'recordRow'+index">
                                                            <td><router-link class="color-blue" target="_blank" v-bind:to="{name: 'RentalAgreementInvoice',params:{id:record.invoice_id}}">{{record.invoice_no}}</router-link></td>
                                                            <td>{{record.unit_no}}</td>
                                                            <td>{{record.description}}</td>
                                                            <td class="text-right">{{record.billed_days}}</td>
                                                            <td class="text-right">{{record.rate}}</td>
                                                            <td>{{record.per_value}}</td>
                                                            <td class="text-right">{{record.billed_amount}}</td>
                                                            <td class="text-right">{{record.create_date}}</td>
                                                            <td>{{record.selected}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <tr><td colspan="8" class="text-center">No Record Found</td></tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="rebill" class="list-sections table-responsive-sm" style="margin-top:30px !important;">
                                    <table aria-describedby="table" id="unit_table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Unit No.</th>
                                                <th>Section/Charge</th>
                                                <th class="text-right">Rate</th>
                                                <th class="text-center">Billing Date</th>
                                                <th class="text-center">Billed Reading</th>
                                                <th class="text-center">Reading Date</th>
                                                <th class="text-center">New Reading</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="billedVariableArr && billedVariableArr.length > 0">
                                                <template v-for="(bill, ind) in billedVariableArr">
                                                    <tr v-bind:key="'recordRow'+ind">
                                                        <td>{{bill.unit_no}}</td>
                                                        <td>{{bill.section}}</td>
                                                        <td class="text-right">{{bill.rate}}</td>
                                                        <td class="text-center">{{bill.invoice_date}}</td>
                                                        <td class="text-center">{{bill.reading_in}}</td>
                                                        <td class="text-center">{{bill.reading_in_date}}</td>
                                                        <td class="text-center">
                                                            <input type="text" placeholder="Reading In" v-model="bill.new_reading" class="form-control" @keypress="isAmountCheck($event)">
                                                            <div class="field-error">{{bill.new_reading_error_msg}}</div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr><td colspan="8" class="text-center">No Record Found</td></tr>
                                            </template>
                                        </tbody>
                                    </table>
                                    <div class="btn-groups">
                                        <button type="submit" id="postRebill" class="btn btn-primary" v-on:click.prevent="postRebill()">
                                            <i class="fp-reload"> </i> Update
                                        </button>

                                        <button type="submit" id="cancelRebill" class="btn btn-tertiary" v-on:click.prevent="cancelRebill">
                                            <i class="fp-close"> </i> Cancel
                                        </button>
                                    </div>
                                </div>
                            </template>
                            <div v-if="activetab == 3" class="list-sections">
                                <!-- <h5>Rental Rates</h5>
                                <button v-if="scopeRateFound == 1" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="updateScopeRate()">
                                    <i class="fp-edit-icon"> </i> Edit
                                </button> -->
                                <div class="page-title adjustTitleWidth">{{ customerName + " | " + rentalTypeCode }}</div>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Rate Type</th>
                                                <th class="text-right">Day</th>
                                                <th class="text-right">Discount %</th>
                                                <th class="text-right">Week</th>
                                                <th class="text-right">Discount %</th>
                                                <th class="text-right">Month</th>
                                                <th class="text-right">Discount %</th>
                                                <th class="text-center">Discount Reasons</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="finalRates && finalRates.length > 0">
                                                <template v-for="(rates, key) in finalRates">
                                                    <tr v-bind:key="'rateRow'+key">
                                                        <td>{{ rates.name }}</td>
                                                        <template v-if="rates.mile || rates.hour">
                                                            <td class="text-right" v-if="rates.hour">${{ rates.hour }}</td>
                                                            <td class="text-right" v-else>${{ rates.mile }}</td>
                                                            <td class="text-right">&nbsp;</td>
                                                            <td class="text-right" v-if="rates.hour">${{ rates.hour }}</td>
                                                            <td class="text-right" v-else>${{ rates.mile }}</td>
                                                            <td class="text-right">&nbsp;</td>
                                                            <td class="text-right" v-if="rates.hour">${{ rates.hour }}</td>
                                                            <td class="text-right" v-else>${{ rates.mile }}</td>
                                                            <td class="text-right">&nbsp;</td>
                                                            <td class="text-center">&nbsp;</td>
                                                        </template>
                                                        <template v-else>
                                                            <td class="text-right" v-if="rates.day">${{ rates.day }}</td><td class="text-right" v-else>-</td>
                                                            <td class="text-right">&nbsp;</td>
                                                            <td class="text-right" v-if="rates.week">${{ rates.week }}</td><td class="text-right" v-else>-</td>
                                                            <td class="text-right">&nbsp;</td>
                                                            <td class="text-right" v-if="rates.month">${{ rates.month }}</td><td class="text-right" v-else>-</td>
                                                            <td class="text-right">&nbsp;</td>
                                                            <td class="text-center">&nbsp;</td>
                                                        </template>
                                                    </tr>
                                                    <template v-if="rates.discount_found == 1">
                                                        <tr v-bind:key="'discountRow'+key">
                                                            <td>&nbsp;</td>
                                                            <template v-if="rates.mile || rates.hour">
                                                                <td class="text-right" v-if="rates.hour_rate">${{ rates.hour_rate }}</td>
                                                                <td class="text-right" v-else>${{ rates.mile_rate }}</td>
                                                                <td class="text-right" v-if="rates.hour_discount">{{ rates.hour_discount }}<span v-if="rates.hour_discount_type != undefined &&rates.hour_discount_type == '$' ">$</span><span v-else>%</span></td>
                                                                <td class="text-right" v-else>{{ rates.mile_discount }}<span v-if="rates.mile_discount_type != undefined &&rates.mile_discount_type == '$' ">$</span><span v-else>%</span></td>
                                                                <td class="text-right" v-if="rates.hour_rate">${{ rates.hour_rate }}</td>
                                                                <td class="text-right" v-else>${{ rates.mile_rate }}</td>
                                                                <td class="text-right" v-if="rates.hour_discount">{{ rates.hour_discount }} <span v-if="rates.hour_discount_type != undefined && rates.hour_discount_type == '$' ">$</span><span v-else>%</span></td>
                                                                <td class="text-right" v-else>{{ rates.mile_discount }}<span v-if="rates.mile_discount_type != undefined && rates.mile_discount_type == '$' ">$</span><span v-else>%</span></td>
                                                                <td class="text-right" v-if="rates.hour_rate">${{ rates.hour_rate }}</td>
                                                                <td class="text-right" v-else>${{ rates.mile_rate }}</td>
                                                                <td class="text-right" v-if="rates.hour_discount">{{ rates.hour_discount }}<span v-if="rates.hour_discount_type != undefined && rates.hour_discount_type == '$' ">$</span><span v-else>%</span></td>
                                                                <td class="text-right" v-else>{{ rates.mile_discount }}<span v-if="rates.mile_discount_type != undefined &&rates.mile_discount_type == '$' ">$</span><span v-else>%</span></td>
                                                                <td>{{rates.discount_reason}}</td>
                                                            </template>
                                                            <template v-else>
                                                                <td class="text-right" v-if="rates.day_rate">${{ rates.day_rate }}</td><td class="text-right" v-else>-</td>
                                                                <td class="text-right" v-if="rates.day_discount">{{ rates.day_discount }}<span v-if="rates.day_discount_type != undefined &&rates.day_discount_type == '$' ">$</span><span v-else>%</span></td><td class="text-right" v-else>&nbsp;</td>
                                                                <td class="text-right" v-if="rates.week_rate">${{ rates.week_rate }}</td><td class="text-right" v-else>-</td>
                                                                <td class="text-right" v-if="rates.week_discount">{{ rates.week_discount }}<span v-if="rates.week_discount_type != undefined &&rates.week_discount_type == '$' ">$</span><span v-else>%</span></td><td class="text-right" v-else>&nbsp;</td>
                                                                <td class="text-right" v-if="rates.month_rate">${{ rates.month_rate }}</td><td class="text-right" v-else>-</td>
                                                                <td class="text-right" v-if="rates.month_discount">{{ rates.month_discount }}<span v-if="rates.month_discount_type != undefined &&rates.month_discount_type == '$' ">$</span><span v-else>%</span></td><td class="text-right" v-else>&nbsp;</td>
                                                                <td>{{rates.discount_reason}}</td>
                                                            </template>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr><td colspan="8" class="text-center">No rates found</td></tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups text-left" v-if="!fromApprove && status != 'approved' && isRateReject === 'true'">
                                    Reject Reason: <strong style="color:red;">{{rate_reject_reason}}</strong>
                                </div>
                                <div class="btn-groups text-left" v-if="scopeRateFound == 1 && fromApprove && exDate != ''">
                                    Rates Required Approval Till {{exDate}}
                                </div>

                                <div class="btn-groups text-right">
                                <button v-if="!fromApprove" type="submit" class="btn btn-primary agreement-scope-rate-edit-btn" v-on:click.prevent="updateScopeRate()">
                                    <i class="fp-edit-icon"> </i> Edit
                                </button>
                                <button v-if="scopeRateFound == 1 && (((fromApprove || canApproveRates) && rate_status == 'pending') || exDate != '')" type="submit" class="btn btn-primary agreement-scope-rate-edit-btn" v-on:click.prevent="approveRates('approve')">
                                    Approve
                                </button>
                                <button v-if="scopeRateFound == 1 && (((fromApprove || canApproveRates) && rate_status == 'pending') || exDate != '')" type="submit" class="btn btn-primary agreement-scope-rate-edit-btn" v-on:click.prevent="approveRates('reject')">
                                    Reject
                                </button>
                                <button v-if="!fromApprove && status != 'approved' && isRateReject === 'true'" type="submit" class="btn btn-primary agreement-scope-rate-edit-btn" v-on:click.prevent="setDefaultRate()">
                                    Set To Default
                                </button>
                                </div>
                            </div>
                            <template v-if="activetab == 4" class="list-sections">
                                <div  v-if="insuranceChargesArr && insuranceChargesArr.length > 0 && !updateCharge">
                                    <!-- <h2>Insurance Charges Details</h2> -->
                                    <div class="section-divider">
                                        <div class="table-responsive-sm">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>Charge Name</th>
                                                        <th>Days</th>
                                                        <th class="text-right">Charge</th>
                                                        <th class="text-right">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="insuranceChargesArr && insuranceChargesArr.length > 0">
                                                        <template v-for="(row, index) in insuranceChargesArr">
                                                            <tr v-if="row.physical_ins_charges != undefined" :key="'physical_ins' + index">
                                                                <td>{{row.phy_charges_name}}</td>
                                                                <td>{{row.days}} Days</td>
                                                                <td class="text-right">${{numberFormat(row.physical_ins_charges)}}</td>
                                                                <td class="text-right">${{numberFormat(row.physical_ins_total)}}</td>
                                                            </tr>

                                                            <tr v-if="row.physical_admin_charges != undefined" :key="'physical_admin' + index">
                                                                <td>{{row.phy_admincharges_name}}</td>
                                                                <td>-</td>
                                                                <td class="text-right">${{numberFormat(row.physical_admin_charges)}}</td>
                                                                <td class="text-right">${{numberFormat(row.physical_admin_total)}}</td>
                                                            </tr>

                                                            <tr v-if="row.liability_insurance_charges != undefined" :key="'liability_ins' + index">
                                                                <td>{{row.lia_insurance_name}}</td>
                                                                <td>{{row.days}} Days</td>
                                                                <td class="text-right">${{numberFormat(row.liability_insurance_charges)}}</td>
                                                                <td class="text-right">${{numberFormat(row.liability_insurance_total)}}</td>
                                                            </tr>

                                                            <tr v-if="row.liability_admin_charges != undefined" :key="'liability_admin' + index">
                                                                <td>{{row.lia_admincharges_name}}</td>
                                                                <td>-</td>
                                                                <td class="text-right">${{numberFormat(row.liability_admin_charges)}}</td>
                                                                <td class="text-right">${{numberFormat(row.liability_admin_total)}}</td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <tr><td colspan="4" class="text-center">No Insurance Charges Found.</td></tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="insuranceChargesArr.length == 0">
                                    No Data Found
                                </div>
                                <!-- Edit Charge Button -->
                                <!-- <button v-if="closed == 0 && insuranceChargesArr && insuranceChargesArr.length > 0 && !updateCharge" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="editCharges()">
                                    <i class="fp-edit-icon"> </i> Edit
                                </button> -->
                                <h4 v-if="insuranceChargesArr.length > 0 && !updateCharge"> Insurance Certificate </h4>
                                <div class="attachment-view-internal-section" v-if="insuranceChargesArr.length > 0 && !updateCharge">
                                    <template v-if="insCertificateFiles.length > 0">
                                        <template v-for="(doc,vkey) in insCertificateFiles">
                                            <div v-bind:key="'fileDiv'+vkey" class="attachment-list">
                                                <i v-if="doc.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                <i v-if="doc.extension == 'doc' || doc.extension == 'docs'" class="fp-text-document"></i>
                                                <i v-if="doc.extension == 'jpg' ||  doc.extension == 'png' ||  doc.extension == 'jpeg' " class="fp-image"></i>
                                                <!-- <a :key="vkey" href="javascript:void(0)" class="customer-detail-rv" v-on:click="openDocument(doc.url,doc.extension)">  {{splitString(doc.file_name)}}</a> -->
                                                <a :key="vkey" href="javascript:void(0)" class="customer-detail-rv" v-on:click="openDocument(doc.url,doc.extension)">  {{doc.display_name}}</a>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <span>No Insurance Certificate found.</span>
                                    </template>
                                </div>
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="chargeForm" v-if="insuranceChargesArr && insuranceChargesArr.length > 0 && updateCharge">
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col">Charge Name</th>
                                                    <th scope="col">Days</th>
                                                    <th scope="col"> Charge </th>
                                                    <th scope="col"> Total </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="rows && rows.length > 0">
                                                    <template v-for="(row, index) in rows">
                                                        <tr :key="'physical_ins_row' + index">
                                                            <td>{{row.charge_name}}</td>
                                                            <template v-if="row.charge_identifier != 'physical_admin_fee' && row.charge_identifier != 'liability_admin_fee'">
                                                                <td>{{row.days}} Days</td>
                                                            </template>
                                                            <template v-else>
                                                                <td>-</td>
                                                            </template>
                                                            <td class="text-right">
                                                                <input type="text" placeholder="Enter Charge"  v-model="row.rate" v-on:keyup="calculateChargeTotal($event,index)" @keypress="isAmountCheck($event)" id="rate" name="rate" class="form-control text-right">
                                                                <div class="error error-font">{{row.rate_error_msg}}</div>
                                                            </td>
                                                            <td class="text-right">${{numberFormat(row.total)}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="btn-groups text-right">
                                        <button type="submit" v-if="insuranceChargesArr.length > 0" id="CreateChargeBtn" class="btn btn-primary" v-on:click.prevent="updateCharges">
                                            <i class="fp-reload"> </i> Update
                                        </button>
                                        <button type="submit" id="CancelChargeBtn" class="btn btn-tertiary" v-on:click.prevent="backChargeList">
                                            <i class="fp-close"> </i> Cancel
                                        </button>
                                    </div>
                                </form>
                            </template>
                            <div v-if="activetab == 5" class="list-sections">
                                    <!-- <h2>Insurance Policy Details</h2> -->
                                    <div class="btn-groups text-right">
                                        <button v-if="status === 'active'" type="submit" class="btn btn-primary" v-on:click.prevent="updateRentalAgreement('policy')">
                                            <i class="fp-edit-icon"> </i> Add Policy
                                        </button>
                                        <p>&nbsp;</p>
                                    </div>
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Policy Number</th>
                                                    <th>Insurance Company</th>
                                                    <th>Policy Owner</th>
                                                    <th>Agent Name</th>
                                                    <th>Agent Contact</th>
                                                    <th>Status</th>
                                                    <th>Start Date</th>
                                                    <th>Expiry Date</th>
                                                    <th>Blanket Policy</th>
                                                    <th>Policy Type</th>
                                                    <th>Self Insured For</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="insurancePolicyArr && insurancePolicyArr.length > 0">
                                                    <template v-for="(row, index) in insurancePolicyArr">
                                                        <tr v-bind:key="'insPolicy'+index">
                                                            <td>{{row.policy_number}}</td>
                                                            <td>{{row.insurance_company_name}}</td>
                                                            <td>{{row.policy_owner}}</td>
                                                            <td>{{row.agent_name}}</td>
                                                            <td>{{row.agent_contact}}</td>
                                                            <td>{{row.status}}</td>
                                                            <td>{{row.start_date}}</td>
                                                            <td>{{row.expiry_date}}</td>
                                                            <td v-if="row.is_rental_blanket == 1">Yes</td>
                                                            <td v-else>No</td>
                                                            <td>{{row.policy_type}}</td>
                                                            <td>{{row.self_insured_for}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <tr><td colspan="10" class="text-center">No Insurance Policy Found.</td></tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                            </div>
                            <div id="billing" v-if="activetab == 7">
                                <div class="list-sections">
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Unit No.</th>
                                                    <th>Section/Charge</th>
                                                    <th class="text-right">Billed Days</th>
                                                    <th class="text-right">Billing Rate</th>
                                                    <th class="text-center">&nbsp;&nbsp;</th>
                                                    <th class="text-right">Billed Amount</th>
                                                    <!-- <th class="text-right">Billed Taxes</th> -->
                                                    <th class="text-center">Selected</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="billingArr && billingArr.length > 0">
                                                    <template v-for="(bill, index) in billingArr">
                                                        <tr v-bind:key="'recordRow'+index">
                                                            <td>{{bill.unit_no}}</td>
                                                            <td>{{bill.description}}</td>
                                                            <td class="text-right">{{bill.billed_days}}</td>
                                                            <td class="text-right">{{bill.rate}}</td>
                                                            <td class="text-center">{{bill.per_value}}</td>
                                                            <td class="text-right">{{bill.billed_amount}}</td>
                                                            <!-- <td class="text-right">{{bill.taxes}}</td> -->
                                                            <td class="text-center">{{bill.selected}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <tr><td colspan="8" class="no-data-field">No Record Found</td></tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div v-if="activetab === 9" class="list-sections">
                                 <app-contract-miscellaneous-charge-tab :from="'agreement'"></app-contract-miscellaneous-charge-tab>
                            </div>
                             <div id="billingdays" v-if="activetab == 8">
                                <div class="list-sections">
                                    <app-discounted-days-tab :from="'agreement'"></app-discounted-days-tab>
                                </div>
                            </div>
                            <div id="agreement-activity-log" class="list-view" v-show="activetab == 6">
                                <div class="bg-white data-table p-0">
                                    <agreement-activity-log-list :activityLogVal="activityLogsTabValue"></agreement-activity-log-list>
                                </div>
                            </div>
                            <div id="customer-credit-request" class="list-view" v-show="activetab == 11">
                                <!-- <section class="interna-container border-top-table-fl"> -->
                                    <div class="bg-white data-table p-0">
                                    <app-customer-credit-request ref="creditForm" v-if="enableCustomerCreditRequest" :customerId="customerId" :from="'agreement'" :agreementId="parseInt($route.params.id)"></app-customer-credit-request>
                                    </div>
                                <!-- </section> -->
                            </div>
                            <div id="agreement-activity-log" class="list-view" v-if="activetab == 10">
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="" class="table table-sm table-bordered font-1" v-if="osrVoucherArr.length > 0">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Voucher</th>
                                                <th>Invoice</th>
                                                <th>Vendor PO</th>
                                                <th>Vendor</th>
                                                <th>Status</th>
                                                <th>Amount</th>
                                                <th>Invoice Date</th>
                                                <th>Due Date</th>
                                                <th>Invoice Add Date</th>
                                                <th>Verified By</th>
                                                <th>Approved By</th>
                                                <th>Monthly Payable</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="osrVoucherArr.length > 0">
                                                <template v-for="(record, index) in osrVoucherArr">
                                                    <tr v-bind:key="'recordRow'+index">
                                                        <td>
                                                          <!-- <router-link title="View Vendor Invoice" class="color-blue"
                                                          v-bind:to="{name: 'BillView',params:{id:record.id}}">
                                                          {{record.voucher_number}}
                                                          </router-link> -->

                                                        <a href="javascript:void(0)" title="View Vendor Invoice" class="color-blue"
                                                          v-on:click="goToVoucher(record.id)">
                                                          {{record.voucher_number}}
                                                          </a>
                                                        </td>
                                                        <td>{{record.bill_number}}</td>
                                                        <td>{{record.po_number}}</td>
                                                        <td>{{record.vendor}}</td>
                                                        <td>{{record.status}}</td>
                                                        <td>{{record.amount}}</td>
                                                        <td>{{record.bill_date}}</td>
                                                        <td>{{record.due_date}}</td>
                                                        <td>{{record.invoice_add_date}}</td>
                                                        <td>{{record.verified_by_name}}</td>
                                                        <td>{{record.approved_by_name}}</td>
                                                        <td>{{record.monthly_payable}}</td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr><td colspan="8" class="text-center">No Record Found</td></tr>
                                            </template>
                                        </tbody>
                                    </table>
                                    <h5 v-if="osrVoucherArr.length == 0">No Record Found...</h5>
                                </div>


                            </div>

                        </section>
                    </div>
                </div>

                <div class="modal fade make-bill-date-modal" id="postInvoiceModal" ref="postInvoiceModal" data-backdrop="static" data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Post Invoice</h5>
                                <button type="button" class="close" id="btnBillModalClose" v-on:click="hideBillModal()">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div class="form-row">
                                    <div class="col form-group" v-if="!forFirstInvoice">
                                        <label class="control-label require" for="bill_date">Bill Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="bill_date" name="bill_date" v-model="bill_date" :config="optionsDate"></date-picker>
                                            <label for="bill_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ bill_date_error }}</div>
                                    </div>
                                </div>
                                <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Unit No.</th>
                                                    <th>Section/Charge</th>
                                                    <th class="text-right">Billed Days</th>
                                                    <th class="text-right">Billing Rate</th>
                                                    <th class="text-center">&nbsp;&nbsp;</th>
                                                    <th class="text-right">Billed Amount</th>
                                                    <!-- <th class="text-right">Billed Taxes</th> -->
                                                    <th class="text-center">Selected</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="billingArr && billingArr.length > 0">
                                                    <template v-for="(bill, index) in billingArr">
                                                        <tr v-bind:key="'recordRow'+index">
                                                            <td>{{bill.unit_no}}</td>
                                                            <td>{{bill.description}}</td>
                                                            <td class="text-right">{{bill.billed_days}}</td>
                                                            <td class="text-right">{{bill.rate}}</td>
                                                            <td class="text-center">{{bill.per_value}}</td>
                                                            <td class="text-right">{{bill.billed_amount}}</td>
                                                            <!-- <td class="text-right">{{bill.taxes}}</td> -->
                                                            <td class="text-center">{{bill.selected}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <tr><td colspan="8" class="no-data-field">No Record Found</td></tr>
                                                </template>
                                            </tbody>
                                        </table>
                                        <p style="color:red" v-if="!forFirstInvoice && !amount">No billing found. You can close the agreement by clicking on Close</p>

                                    </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-primary" id="btnPostInvoiceModalProcess" v-if="forFirstInvoice || amount" v-on:click="postInvoice()"> Post Invoice </button>
                                <button class="btn btn-primary" v-if="!forFirstInvoice && !amount" id="btnPostInvoiceModalClose" v-on:click="closeAgreement()"> Close Agreement</button>
                                <button class="btn btn-tertiary" id="btnPostInvoiceModalCancel" v-on:click="hideBillModal()"> Cancel </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade make-bill-date-modal" id="check-date-modal" ref="check-date-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="check-date-modal" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content widthCustom">
                            <div class="modal-header">
                                <h5 class="modal-title">Process</h5>
                                <button type="button" class="close" id="btnBillModalClose" v-on:click="hideBillModal()">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div class="form-row">
                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label">Actual From Date</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="actual_from_date" name="actual_from_date" v-model="actual_from_date" :config="toActualFromDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="actual_from_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{actual_from_datetime_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="rentalType">Actual From Time:</label>
                                        <!-- <v-select class="close-remove" v-model="actual_from_time"  id="actual_from_time" label="text" :options="timeArr" placeholder="Select Actual From Time.">
                                        </v-select> -->
                                        <div class="input-group">
                                            <input type="text" v-cleave="{time: true,timePattern: ['h','m']}" class="form-control" v-model="actual_from_time" @keyup="validateTime($event)" id="actual_from_time" placeholder="HH:MM" name="actual_from_time1">
                                            <!-- <input-mask id="actual_from_time" :alwaysShowMask="true" name="actual_from_time1" v-model="actual_from_time" :mask="timeMask"
                                                :format-chars="timeMaskOptions.formatChars"
                                                :always-show-mask="timeMaskOptions.alwaysShowMask" class="form-control">
                                            </input-mask> -->
                                            <div class="input-group-append">
                                                <v-select v-model="actual_from_ampm" class="close-remove" name="actualFromAmPm" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{actual_from_time_error_msg}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-primary" id="btnPostInvoiceModalProcess" v-on:click="checkTriggers('validate')"> Process </button>
                                <button class="btn btn-tertiary" id="btnPostInvoiceModalCancel" v-on:click="hideDateModal()"> Cancel </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade make-bill-date-modal" id="check-due-date-modal" ref="check-due-date-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="check-due-date-modal" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content widthCustom">
                            <div class="modal-header">
                                <h5 class="modal-title">Extend Agreement</h5>
                                <button type="button" class="close" id="btnBillModalClose" v-on:click="hideDueInModal()">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div class="form-row">
                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label">Due In Date</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="due_in_date" name="due_in_date" v-model="due_in_date" :config="toActualFromDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="due_in_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{due_in_datetime_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="rentalType">Due In Time:</label>
                                        <!-- <v-select class="close-remove" v-model="actual_from_time"  id="actual_from_time" label="text" :options="timeArr" placeholder="Select Actual From Time.">
                                        </v-select> -->
                                        <div class="input-group">
                                            <input type="text" v-cleave="{time: true,timePattern: ['h','m']}" class="form-control" v-model="due_in_time" @keyup="validateTime($event)" id="due_in_time" placeholder="HH:MM" name="due_in_time">
                                            <!-- <input-mask id="due_in_time" :alwaysShowMask="true" name="due_in_time" v-model="due_in_time" :mask="timeMask"
                                                :format-chars="timeMaskOptions.formatChars"
                                                :always-show-mask="timeMaskOptions.alwaysShowMask" class="form-control">
                                            </input-mask> -->
                                            <div class="input-group-append">
                                                <v-select v-model="due_in_ampm" class="close-remove" name="dueFromAmPm" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{due_in_time_error_msg}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-primary" id="btnPostInvoiceModalProcess" v-on:click="updateDueOut()"> Update </button>
                                <button class="btn btn-tertiary" id="btnPostInvoiceModalCancel" v-on:click="hideDueInModal()"> Cancel </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade trigger-message-modal" v-show="displaySchedule" id="trigger-message-modal" ref="triggerMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="triggerMessageModal" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Maintenance For:</h5>
                                <button type="button" class="close" id="btnPermitModalMessageClose" v-on:click="checkTriggers('no_action')">&times;</button>
                            </div>
                            <div class="modal-body">
                                   <app-program-trigger :from="'rental agreement'" ref="triggerEnable"></app-program-trigger>
                            </div>
                            <div class="modal-footer">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="vendorInvoiceModal" ref="triggerMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="triggerMessageModal" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Add Vendor Invoice</h5>
                                <button type="button" class="close" v-on:click="closeAddVendorInvoice()">&times;</button>
                            </div>
                            <div class="modal-body">

                              <div class="col-md-12 ">
                                  <div class="row form-group">
                                      <label class="col">Company: </label>
                                      <span class="col"> {{companyId}} </span>
                                  </div>
                                  <div class="row form-group">
                                    <label class="col">PO: </label>
                                    <span class="col"> {{vendorPoNo}} </span>
                                  </div>
                                  <div class="row form-group">
                                      <label class="col">Vendor Name: </label>
                                      <span class="col"> {{vendorName}} </span>
                                  </div>
                                  <div class="row form-group">
                                      <label class="col">Vendor Code: </label>
                                      <span class="col"> {{vendorCode}} </span>
                                  </div>
                                  <div class="row form-group">
                                      <label class="col">Unit No.: </label>
                                      <span class="col"> {{unitNo}} </span>
                                  </div>

                                  <div class="row form-group">
                                      <label class="col">File: </label>
                                      <span class="col">
                                        <div class="custom-upload-container" data-provides="fileupload">
                                            <label for="physicalFiles" class="fileupload-new btn btn-secondary" v-if="!isUpdate"><i class="fp-upload"></i>Upload</label>
                                            <label for="physicalFiles" class="fileupload-exists btn btn-secondary" v-if="isUpdate"><i class="fp-upload"></i>Change</label>
                                            <input class="hide" type="file" id="physicalFiles" ref="files" v-on:change="handleFilesUpload()"/>
                                            <!-- <div class="field-error">{{fileerror_msg}}</div> -->
                                        </div>
                                        <div class="field-error">{{fileerror_msg}}</div>

                                        <template v-if="!isUpdate">
                                            <template v-for="(file, key) in filesArr">
                                                <div v-bind:key="key" class="file-container" :id="'fileDiv'+file.id">
                                                    <span class="fileupload-preview">{{ file.name }}</span>
                                                    <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteDoc(file.id,key)" style="float: right">
                                                        <i class="fp-delete"></i>
                                                    </a>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template  v-for="(files, key1) in existFilesArr">
                                                <div v-bind:key="key1" class="file-container">
                                                    <a href="javascript:void(0)" class="fileupload-preview" v-on:click="openDocument(files.url,files.ext)">{{ files.display_name }}</a>
                                                    <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteBillFile(key1,files.path)" style="float: right">
                                                        <i class="fp-delete"></i>
                                                    </a>
                                                </div>
                                            </template>
                                        </template>
                                      </span>
                                  </div>

                                  <div class="row form-group">
                                      <label class="col">Invoice Number: </label>
                                      <span class="col">
                                          <input type="text" v-model="vendorInvoiceNumber" placeholder="Invoice Number" class="form-control">
                                          <!--template v-if="isProceedInvoiceDetail"> {{vendorInvoiceNumber}} </template-->
                                          <div class="field-error">{{ vendor_invoice_number_error_msg }}</div>
                                      </span>
                                  </div>

                                  <div class="list-sections">
                                    <template>



                                      <div class="row form-group">
                                        <label class="col">Invoice Date: </label>
                                        <span class="col">
                                          <date-picker placeholder="MM/DD/YYYY" id="vendorInvoiceBillDate"
                                          name="vendorInvoiceBillDate" v-model="vendorInvoiceBillDate"
                                          :config="vendorInvoiceOptionsDate">
                                          </date-picker>
                                          <label for="vendorInvoiceBillDate"
                                          class="fp-calendar input-calender-icon" style="margin-right: 10px;"></label>
                                          <div class="field-error">{{ bill_date_error_msg }}</div>
                                        </span>
                                      </div>

                                      <div class="row form-group">
                                        <label class="col">Due Date: </label>
                                        <span class="col">
                                          <date-picker placeholder="MM/DD/YYYY" id="due_date"
                                          name="due_date" v-model="due_date" :config="optionsDueDate"></date-picker>
                                          <label for="vendorInvoiceBillDate"
                                          class="fp-calendar input-calender-icon" style="margin-right: 10px;"></label>
                                          <div class="field-error">{{ due_date_error_msg }}</div>
                                        </span>
                                      </div>

                                      <div class="row form-group">
                                          <label class="col">Net Amount: </label>
                                          <span class="col">
                                              <input type="text" placeholder="Net Amount" v-model="invoiceNetAmount"
                                              class="form-control" @keypress="isAmountCheck($event)">
                                              <div class="field-error">{{ net_amount_error_msg }}</div>

                                          </span>
                                      </div>

                                      <div class="row form-group">
                                          <label class="col">Estimated Cost: </label>
                                          <span class="col">
                                              {{ vendPo_estimated_cost }}
                                          </span>
                                      </div>

                                    </template>
                                  </div>
                              </div>




                            </div>
                            <div class="modal-footer">
                              <button class="btn btn-primary" v-on:click="processInvoice()"> {{ saveBtnText }} </button>
                              <button class="btn btn-tertiary" v-on:click="closeAddVendorInvoice()"> Cancel </button>
                            </div>
                        </div>
                    </div>
                </div>


            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from ".././event-bus";
import {commonMixins} from '../../mixins/commonMixins';

import MiscellaneousChargeTabView from "@/components/ContractMiscellaneousChargeTabView";
import DiscountedDaysList from "@/components/DiscountedDaysList";
import ProgramTrigger from "@/components/ProgramTrigger.vue";
import moment from 'moment';
// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask);

Vue.component("app-contract-miscellaneous-charge-tab", MiscellaneousChargeTabView);
Vue.component("app-discounted-days-tab", DiscountedDaysList);
Vue.component("app-program-trigger", ProgramTrigger);
var self;
export default {
  name: "InsurancePolicyCreate",
  components: {

        AgreementActivityLogList: () => import('@/components/ActivityLogList.vue'),
        appCustomerCreditRequest:() => import('@/components/CustomerCreditRequest'),

    },
  mixins:[commonMixins],
  data: () => ({
    osrVoucherArr: [],
    fileerror_msg: '',
    filesArr: [],
    isUpdate:false,
    term_period: '',
    term: '',
    vendPo_estimated_cost: '',
    vendorInvoiceId: '',
    vendorPoNo: '',
    vendorInvoiceVoucherNumber: '',
    vendor_invoice_number_error_msg: '',
    net_amount_error_msg: '',
    saveBtnText: 'OK',
    invoiceNetAmount: "",
    due_date: "",
    due_date_error_msg: '',
    optionsDueDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    vendorInvoiceBillDate: new Date(),
    bill_date_error_msg: '',
    vendorInvoiceOptionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    isProceedInvoiceDetail: true,
    vendorInvoiceNumber: '',
    vendorName: '',
    vendorCode: '',
    companyId: '',
    vendorId: '',
    permissions: [],
    cantAccessPage: "",
    loading:false,
    loadOnce:false,
    code:"",
    unitNo:"",
    unitName:"",
    unitTypeName:"",
    unitTypeCode:'',
    unitGvw:"",
    rentalTypeName:"",
    rentalTypeCode:"",
    resRefNo:"",
    customerName:"",
    assetType:"",
    state:"",
    reason:"",
    estimatedMiles:"",
    readingOut:"",
    readingIn:"",
    actualMiles:"",
    finalRates:"",
    dueOutDateTime:"",
    dueInDateTime:"",
    dueOutLocation:"",
    dueInLocation:"",
    chargeFromDateTime:"",
    chargeToDateTime:"",
    chargeFromLocation:"",
    plannedInDateTime:"",
    actualOutDateTime:"",
    actualOutDate:'',
    actualInDateTime:"",
    insurancePolicyNo:"",
    insuranceCompanyName:"",
    insuranceFromDate:"",
    insuranceTodate:"",
    poNo:"",
    poAmount:"",
    insPolicyNo:"",
    insCompanyName:"",
    insPolicyContactName:"",
    insPolicyAgencyName:"",
    insPolicyAgencyEmail:"",
    insPolicyAgencyPhone:"",
    insPolicyStartDate:"",
    insPolicyExpiryDate:"",
    insPolicyAgencyCode:"",
    bookingId:0,
    bill_date:'',
    bill_date_error:'',
    optionsDate:{
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    actual_to_date:'',
    closed:0,
    billingRecordsArr:[],
    displayMenu:false,
    activetab:1,
    pageKey:"",
    scopeRateFound:0,
    scopeRateId:0,
    insurancePolicyArr:[],
    insuranceChargesArr:[],
    customerInsured:"",
    isSubstitute:"",
    contractAsset:"",
    sub_agreement:'',
    consolidated:"",
    notes:"",
    physicalFromDate:"",
    physicalToDate:"",
    liabilityFromDate:"",
    liabilityToDate:"",
    showFields:false,
    updateCharge:false,
    rows:[],
    activityLogsTabValue:"dontLoadList",
    tabMenuArray:[],
    canEditAfterClose:false,
    insCertificateFiles:[],
    billingArr:[],
    billingLoaded:false,
    status:'',
    void_reason:'',
    reqAssetType:'',
    billedVariableArr:[],
    rebill:false,
    vehicle_id:0,
    unitArr:[],
    is_national_lease:0,
    displaySchedule:false,
    pagePath:"",
    billing_frequency:'',
    forFirstInvoice:false,
    isBilled:'no',
    fromApprove:false,
    rate_status:'',
    rate_reject_reason:'',
    isRateReject:'false',
    exDate:'',
    existRequired:'true',
    contractTypeId:0,
    customerId:0,
    custCreditApprReqStatus:"",
    bedgeClass:"",
    enableCustomerCreditRequest:false,
    amount:false,
    fuel_required:0,
    damage_return:0,
    actual_from_time: "",
    actual_from_date:'',
    actual_from_ampm:{text:'AM',value:'am'},
    toActualFromDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false
    },
    actual_from_time_error_msg:'',
    actual_from_datetime_error_msg:'',
    actualFromTime:'',
    dateAdded:'false',
    due_in_date : '',
    due_in_time : '',
    due_in_time_error_msg: '',
    due_in_datetime_error_msg:'',
    due_in_ampm:{text:'AM',value:'am'},
    dueInDate:'',
    dueInTime:'',
    sub_unit:'',
    postOnce:0,
    canApproveRates:false,
    discountDayGen:'no',
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'view_rental_agreement') {
                        self.cantAccessPage = true;
                        self.displayMenu = true;
                        setTimeout(function(){
                            $('.right-asset-tab-list').on('click', 'li', function() {
                                $('.right-asset-tab-list li.active').removeClass('active');
                                $(this).addClass('active');
                            });
                        },200);
                    }
                    if (permissions[i].name == 'edit_after_close_agreement') {
                        self.canEditAfterClose = true;
                    }
                    if (permissions[i].name == 'can_approve_rate') {
                        self.canApproveRates = true;
                    }
                }
            }

        },

        due_date: function(due_date) {

          if ( self.vendorInvoiceBillDate != null && self.due_date != null && self.vendorInvoiceBillDate != "" && self.due_date != "" ) {
                var invoiceDate = Date.parse(self.vendorInvoiceBillDate);
                var dueDate = Date.parse(self.due_date);

                if( dueDate <= invoiceDate ) {
                    self.due_date_error_msg = "Due Date should be greater than Invoice Date.";
                } else {
                    self.due_date_error_msg = "";
                }
            }
        },

        vendorInvoiceBillDate: function(vendorInvoiceBillDate) {
          var self = this;
          var newdate = new Date();
          var invoiceDate = new Date(vendorInvoiceBillDate);


          if(self.term_period == 'month') {
            invoiceDate.setMonth(invoiceDate.getMonth()+ self.term);
          } else if (self.term_period == 'days') {
            invoiceDate.setDate(invoiceDate.getDate()+ self.term);
          } else if (self.term_period == 'year') {
            invoiceDate.setFullYear(invoiceDate.getFullYear()+ self.term);
          }
          self.due_date = invoiceDate;
        },

        activetab: function(activated) {
          if(this.activetab == 10) {
            this.getVendorVoucherDetail()
          }
        },


   },
  created: function() {
      self = this;
  },
  computed: {
    timeMask () {
      if (!this.due_out_time || this.due_out_time === '' || this.due_out_time[0] === '2') {
        console.log('23:59')
        return '23:59'
      }
      console.log('29:59')
      return '29:59'
    },
    timeMaskOptions () {
      return { formatChars: { '2': '[0-1]', '3': '[0-9]', '5': '[0-5]', '9': '[0-9]' }, alwaysShowMask: false }
    }
  },
  beforeRouteLeave(to, from, next) {
        var self = this;
        self.left_view_edit_channel(from.fullPath);
        next();
  },
  mounted: function() {

        self.getPermissions();
        var path = window.location.pathname;
        self.pagePath = btoa(path);
        var segments = path.split("/");

        if(self.$route.query.viewTab == 'rental') {
          this.$router.replace({ query: {} });
          setTimeout(function () {
              $("#tabActive li").removeClass("active");
              $('#rentalRates').addClass("active");
              $('#rentalRates').click();
              self.activetab = 3;
          }
              , 2000);
        }

        var webloc = window.location.href;

        var decodeStr = "";

        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

            decodeStr = atob(this.$route.query.data);

        }
        var splited = webloc.split('?');
        if (splited[1]){
            var url = new URL(splited[0]+"?"+decodeStr);
            var from = url.searchParams.get("from");
            self.exDate = url.searchParams.get("date");
            if (self.exDate == undefined){
                self.exDate = '';
            }

            if (from && (from == 'approve' || self.$route.query.from == 'ack')){
                self.fromApprove = true;
                setTimeout(function () {
                    $("#tabActive li").removeClass("active");
                    $('#rentalRates').addClass("active");
                    $('#rentalRates').click();
                    self.activetab = 3;
                },500);
            }
        }

        if (self.$route.query.from != undefined && self.$route.query.from == 'ack'){
            setTimeout(function () {
                $("#tabActive li").removeClass("active");
                $('#rentalRates').addClass("active");
                $('#rentalRates').click();
                self.activetab = 3;
            },500);
        }

        if (segments[3]) {
            setTimeout(function () {
                self.pageKey='_rental_agreement_view_'+segments[3];
                self.loadRentalAgreement();
                self.billingRecords();
            },1000);
        }
  },
  metaInfo() {
    return {
        title: (this.code != "") ? this.code + " | Rental Agreement View | " +process.env.COPYRIGHT_NAME:"Rental Agreement View | " +process.env.COPYRIGHT_NAME
    }
  },
  methods: {
    getVendorVoucherDetail() {
      //
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        console.log("agreement == ", segments[3]);
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/bill/byVendor",
          type: "POST",
          headers: this.ajxHeaders,
          dataType: "json",
          data:{
            agreement_id: segments[3]
          },
          success: function (data) {

              self.loading = false;

              if (data.status == "success") {
                self.osrVoucherArr = data.content;
              }else{
                self.$swal('',data.message,'error');
              }
          },
          error: function (jqXHR, exception) {
              self.loading = false;
              if (jqXHR.status == 0) {
                  self.errorMsg = "Remote server cannot be reached";
              } else {
                  //redirect to login page if user not authenticated
                  if (jqXHR.status == 401) {
                      //clear previous data
                      localStorage.removeItem("user_obj");
                      localStorage.removeItem("tkn");
                      self.$router.push("/");
                  }
                  self.error = jqXHR.responseJSON.message;
              }
          }
        });

        //Join ViewEdit Channel
        self.join_view_edit_channel(segments[1],segments[2],segments[3]);
    },
    deleteDoc: function(id,key) {
        var self = this;

        if (confirm('Are you sure that you want to remove file? ')) {
            self.submitBtn = false;
            console.log( self.$refs.files);
            this.filesArr.splice(key,1)
            self.$refs.files.value = '';
            if (self.valuesFound) {
                self.valuesFound = false;
                self.matchingValuesError = [];
            }
        }

        return;

    },
    handleFilesUpload: function(event) {
        /* Get the uploaded files from the input.*/
        var self = this;
        if (!self.isUpdate) {

            self.filesArr = [];
            self.fileerroor_msg = "";

            let uploadedFiles = "";
            self.uploadBtn= "Uploading...";
            uploadedFiles = self.$refs.files.files;
            for (var i = 0; i < uploadedFiles.length; i++) {

                this.filesArr.push(uploadedFiles[i]);

            }
            console.log(this.filesArr);
            this.$refs.files.value = '';
            self.uploadBtn= "Upload";
        }else{

            if ( self.existFilesArr.length > 0 ) {

                if (confirm('Do you want to upload file? ')) {
                    self.filesArr = [];
                    self.fileerroor_msg = "";

                    let uploadedFiles = "";
                    self.uploadBtn= "Uploading...";
                    uploadedFiles = self.$refs.files.files;
                    for (var i = 0; i < uploadedFiles.length; i++) {

                        this.filesArr.push(uploadedFiles[i]);

                    }
                    console.log(this.filesArr);
                    this.$refs.files.value = '';
                    self.uploadBtn= "Upload";
                    self.isUpdate = false;
                }

            }else{
                self.isUpdate = false;
                self.filesArr = [];
                self.fileerroor_msg = "";

                let uploadedFiles = "";
                self.uploadBtn= "Uploading...";
                uploadedFiles = self.$refs.files.files;
                for (var i = 0; i < uploadedFiles.length; i++) {

                    this.filesArr.push(uploadedFiles[i]);

                }
                console.log(this.filesArr);
                this.$refs.files.value = '';
                self.uploadBtn= "Upload";
            }

        }

    },
    processInvoice() {
      var self = this;
      if(!self.isProceedInvoiceDetail) {
        if(self.vendorInvoiceNumber == '') {
          self.vendor_invoice_number_error_msg = "Invoice Number Required";
        } else {
          self.vendor_invoice_number_error_msg = "";
          self.isProceedInvoiceDetail = true;
          self.saveBtnText = "Save";
        }
      } else {
        var error = false;
        self.net_amount_error_msg = '';
        self.due_date_error_msg = '';
        self.bill_date_error_msg = '';

        if(self.vendorInvoiceBillDate == '' || self.vendorInvoiceBillDate == null) {
          self.bill_date_error_msg = 'Bill Date is Required.';
          error = true;
        }

        if(self.due_date == '' || self.due_date == null) {
          self.due_date_error_msg = 'Due Date is Required.';
          error = true;
        }

        if(self.invoiceNetAmount == '' || self.invoiceNetAmount == null) {
          self.net_amount_error_msg = 'Net Amount is Required.';
          error = true;
        }

        console.log("file == ", self.filesArr.length);

        if ( self.filesArr.length > 0 ) {
            for (var i = 0; i < self.filesArr.length; i++) {

                let file = self.filesArr[i];
                // if(file.size > 5000000){
                //     self.docerrors = 'File Size Should Not Be Greater Than 5 MB';
                // }
                if(file.type == "image/jpeg" || file.type == "image/png" || file.type == 'application/pdf') {
                  self.fileerror_msg = "";
                } else {
                    self.fileerror_msg = 'Only Images or PDF Files Are Allowed (.png / .jpeg / .pdf)';
                    error = true;
                }
            }
        }
        console.log("file error == ", error);
        if (!self.filesArr.length ){
            self.fileerror_msg = 'File Required';
            error = true;
        }
        console.log("error == ", error);

        if(!error) {
          self.vendorInvoiceCreate();
        }
      }
    },
    vendorInvoiceCreate() {
      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");

      let current_datetime = new Date(self.vendorInvoiceBillDate);
      var formattedDate = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear();

      const fields = new FormData();

      for (var i = 0; i < self.filesArr.length; i++) {
          let file = self.filesArr[i];
          fields.append("files[]", file);
      }

      fields.append(
          "bill_number",
          self.vendorInvoiceNumber
      );
      fields.append(
          "bill_date",
          formattedDate
      );
      fields.append(
          "due_date",
          self.due_date
      );
      fields.append(
          "amount",
          self.invoiceNetAmount
      );
      fields.append(
          "vendor_id",
          self.vendorId
      );
      fields.append(
          "rental_agreement_id",
          segments[3]
      );

      // getDateString(new Date(self.vendorInvoiceBillDate), "MM/DD/YYYY")


      self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/vendor/invoice/create",
            type: "POST",
            headers: this.ajxHeaders,
            crossDomain: true,
            processData: false,
            contentType: false,
            dataType: "json",
            data:fields,
            success: function (data) {

                self.loading = false;

                if (data.status == "success") {
                  self.closeAddVendorInvoice();
                  self.loadRentalAgreement();
                  self.billingRecords();
                }else{
                  self.$swal('',data.message,'error');
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    addVendorInvoice() {
      var self = this;
      self.filesArr = [];
      self.existFilesArr = [];
      self.vendorInvoiceNumber = "";
      self.invoiceNetAmount = "";
      $("#vendorInvoiceModal").modal("show");
    },
    closeAddVendorInvoice() {
      self.isProceedInvoiceDetail = true;
      $("#vendorInvoiceModal").modal("hide");
    },
    goPreviousPath() {
      if (this.$route.query.from != undefined && this.$route.query.from != null) {
        if (this.$route.query.from == "gl") {
            self.$router.push("/report/general-ledger");
        }else{
            this.$router.go(-1);
        }
      }else{
        this.$router.go(-1);
      }
    },

    BackRentalAgreeementList() {

      self.$router.push("/rentalagreement/list");
    },

    loadRentalAgreement() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        var fromap = false;

        if (self.fromApprove || self.canApproveRates){
            fromap = true;
        }
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/rentalagreement/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                fromApprove:fromap,
                action_flag : 'view', // pass action for notify: view, edit
                is_notify_flag : true // notify if user viewing or editing
            },
            dataType: "json",
            success: function (data) {

                self.loading = false;
                console.log(data);

                if (data.status == "success") {
                    var storeObject={visited_page: {
                                    path : "rentalagreement |" +data.content.code,
                                    data : window.location.pathname,
                                    }};
                    self.getRecentlyPagesMethod(storeObject);
                    self.vendorName = data.content.vendor_name;
                    console.log("bill date == ",self.vendorInvoiceBillDate)
                    if(data.content.bill_id != null) {
                      self.vendorInvoiceId = data.content.bill_id;
                      self.vendorInvoiceVoucherNumber = data.content.bill_voucher_number;
                      self.vendorInvoiceNumber = data.content.bill_number;
                      self.vendorInvoiceBillDate = new Date(data.content.bill_date);
                      self.due_date = data.content.bill_due_date;
                      self.invoiceNetAmount = data.content.bill_total;
                    }
                    self.vendorCode = data.content.vendor_code;
                    if(data.content.vendor_code != null && data.content.vendor_code != "") {
                      self.companyId = data.content.vendor_code.split("-");
                      self.companyId = self.companyId[0];
                    }
                    self.vendorPoNo = data.content.vendPo_po_no;
                    self.vendorPoId = data.content.vendPo_id;
                    self.vendPo_estimated_cost = "$" + self.numberFormat(data.content.vendPo_estimated_cost);
                    var newdate = new Date();
                    // var newdate = new Date(self.vendorInvoiceBillDate);
                    if(data.content.term_id != null && data.content.term_id != "") {
                      self.term_period = data.content.term_period;
                      self.term = data.content.term;

                      if(data.content.term_period == 'month') {
                        newdate.setMonth(self.vendorInvoiceBillDate.getMonth()+ data.content.term);
                      } else if (data.content.term_period == 'days') {

                        newdate.setDate(self.vendorInvoiceBillDate.getDate()+ data.content.term);
                      } else if (data.content.term_period == 'year') {
                        newdate.setFullYear(self.vendorInvoiceBillDate.getFullYear()+ data.content.term);
                      }
                      self.due_date = newdate;
                    } else {
                      // 30 days
                      self.term_period = 'days';
                      self.term = 30;
                      newdate = new Date(self.vendorInvoiceBillDate);
                      console.log(newdate);
                      newdate.setDate(newdate.getDate()+ self.term);
                      self.due_date = newdate;
                    }
                    self.poNo = data.content.po_no;
                    self.discountDayGen = data.content.discounted_day;
                    self.vendorId = data.content.vendor_id;
                    self.resRefNo = data.content.reference_no;
                    self.code = data.content.code;
                    self.reason = data.content.reason_value;
                    self.readingOut = data.content.reading_out;
                    self.readingIn = data.content.reading_in;
                    self.actualMiles = data.content.difference;
                    self.finalRates = data.content.final_rates;
                    self.rate_status = data.content.rate_status;
                    self.rentalTypeName = data.content.contTypeName;
                    self.rentalTypeCode = data.content.contTypeCode;
                    self.contractTypeId = data.content.contract_type_id;
                    self.customerId = data.content.customer_id;
                    if (data.content.contTypeCode.toLowerCase() == "comp") {
                        self.showFields = false;
                    }else{
                        self.showFields = true;
                    }
                    self.dueOutDateTime = data.content.due_out_date+" "+data.content.due_out_time;
                    self.dueInDateTime = data.content.due_in_date+" "+data.content.due_in_time;
                    self.dueInDate = data.content.due_in_date;
                    self.dueInTime = data.content.due_in_time;
                    // self.chargeFromDateTime = data.content.charge_from_date+" "+data.content.charge_from_time;
                    // self.chargeToDateTime = data.content.charge_to_date+" "+data.content.charge_to_time;
                    if (data.content.actual_from_date != null && data.content.actual_from_date != ''){
                        self.actualOutDateTime = data.content.actual_from_date+" "+data.content.actual_from_time;
                    }
                    self.actualInDateTime = data.content.actual_to_date+" "+data.content.actual_to_time;
                    self.plannedInDateTime = data.content.planned_in_date+" "+data.content.planned_in_time;
                    self.actualOutDate = data.content.actual_from_date;

                    self.actual_to_date = data.content.actual_to_date;
                    self.closed = data.content.closed;
                    self.dueOutLocation = data.content.locOutName;
                    self.dueInLocation = data.content.locInName;
                    self.chargeFromLocation = data.content.locfromName;

                    self.unitNo = data.content.unitNo;
                    self.unitName = data.content.vehicleName;
                    self.unitTypeName = data.content.vehicleTypeName;
                    self.unitTypeCode = data.content.vehicleTypeCode;
                    self.vehicle_id = data.content.vehicle_id;
                    self.reqAssetType = data.content.req_vehicleTypeCode+' | '+data.content.req_vehicleTypeName;
                    self.unitGvw = data.content.unitGvw;

                    if (data.content.custCode != undefined && data.content.custCode != null) {
                        self.customerName = data.content.custCode + ' | ' +data.content.custName;
                    }else{
                        self.customerName = data.content.custName;
                    }
                    self.customerId = data.content.custId;

                    self.poAmount = data.content.poTotal;
                    self.state = data.content.stateName;
                    self.estimatedMiles = data.content.miles;

                    self.insurancePolicyNo = data.content.policy_number;
                    self.insCompanyName = data.content.inName;
                    self.insPolicyAgencyEmail = data.content.agencyEmail;
                    self.insPolicyAgencyPhone = data.content.agencyPhone;
                    self.insPolicyAgencyName = data.content.agencyName;
                    self.insPolicyAgencyCode = data.content.agencyCode;
                    self.insPolicyContactName = data.content.agencyContactName;
                    self.insPolicyStartDate = data.content.policyStartDate;
                    self.insPolicyExpiryDate = data.content.policyExpiryDate;
                    self.bookingId = data.content.bookingId;
                    self.scopeRateFound = data.content.scope_rate_found;
                    self.rate_reject_reason = data.content.rate_reject_reason;
                    self.isRateReject = data.content.is_rate_reject;
                    if (data.content.final_rates.length > 0) {
                        self.scopeRateId = data.content.final_rates[0].scope_rate;
                    }
                    if (data.content.insurance_policy_details.length > 0) {
                        self.insurancePolicyArr = data.content.insurance_policy_details;
                    }
                    if (data.content.insurance_charges_details != null) {
                        self.insuranceChargesArr = data.content.insurance_charges_details;
                    }
                    if (data.content.customer_insured == 1) {
                        self.customerInsured = "Yes";
                    }else{
                        self.customerInsured = "No";
                    }
                    self.consolidated = data.content.consolidated;
                    if (data.content.is_substitute == 1) {
                        self.isSubstitute = "Yes";
                        if (data.content.contract_asset_id != null) {
                            self.contractAsset = data.content.contract_code + " | " + data.content.contract_asset;
                            self.sub_unit = data.content.contract_asset;
                        }else if (data.content.sub_agreement_id != null){
                            self.sub_agreement = data.content.sub_ag_code + " | " + data.content.sub_ag_unit;
                            // self.sub_type = {text:'Rental Sub',value:'rental'};
                            self.sub_unit = data.content.sub_ag_unit;
                        }else{
                            if (data.content.sub_unit != null){
                                self.sub_unit = data.content.sub_unit_number;
                            }else{
                                self.sub_unit = '';
                            }
                            self.contractAsset = "";
                            self.sub_agreement = '';
                        }
                    }else{
                        self.isSubstitute = "No";
                    }
                    if (data.content.notes != null && data.content.notes != "") {
                        self.notes = data.content.notes;
                    }else{
                        self.notes = "-";
                    }
                    if (data.content.physical_from != null) {
                        self.physicalFromDate = data.content.physical_from;
                    }else{
                        self.physicalFromDate = "-";
                    }
                    if (data.content.physical_to != null) {
                        self.physicalToDate = data.content.physical_to;
                    }else{
                        self.physicalToDate = "-";
                    }
                    if (data.content.liability_from != null) {
                        self.liabilityFromDate = data.content.liability_from;
                    }else{
                        self.liabilityFromDate = "-";
                    }
                    if (data.content.liability_to != null) {
                        self.liabilityToDate = data.content.liability_to;
                    }else{
                        self.liabilityToDate = "-";
                    }
                    if (data.content.insurance_certificates != null) {
                        self.insCertificateFiles = data.content.insurance_certificates;
                    }else{
                        self.insCertificateFiles = [];
                    }
                    self.status = data.content.status;
                    self.void_reason = data.content.void_reason;
                    self.billing_frequency = data.content.billing_frequency;
                    self.isBilled = data.content.billed;

                    if (data.content.reading_out && data.content.reading_out.length > 0){
                        for (var i = 0; i < data.content.reading_out.length; i++) {
                            self.unitArr.push({
                                section_id:data.content.reading_out[i].section_id,
                                section:data.content.reading_out[i].section,
                                reading_out:data.content.reading_out[i].reading_out,
                                reading_out_date:data.content.reading_out[i].reading_out_date,
                                reading_out_error_msg:'',
                                reading_out_date_error_msg:'',
                                sectionName:data.content.reading_out[i].sectionName
                            });
                        }
                    }
                    if (data.content.is_national_lease != undefined && data.content.is_national_lease != null) {
                        self.is_national_lease = data.content.is_national_lease;
                    }
                     if (data.content.fuel_required != undefined && data.content.fuel_required != null) {
                        self.fuel_required = data.content.fuel_required;
                    }
                    if (data.content.damage_return != undefined && data.content.damage_return != null) {
                        self.damage_return = data.content.damage_return;
                    }

                    //Check credit override request status..
                    if ( data.content.credit_override_request_status != "" ) {
                        if ( data.content.credit_override_request_status == 'sent' ) {
                            self.custCreditApprReqStatus = "Sent";
                            self.bedgeClass = "badge badge-warning";
                        } else if ( data.content.credit_override_request_status == 'approved' ) {
                            self.custCreditApprReqStatus = "Approved";
                            self.bedgeClass = "badge badge-success";
                        } else {
                            self.bedgeClass = "badge badge-danger";
                            self.custCreditApprReqStatus = "Denied";
                        }

                    }

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    updateRentalAgreement (flag){

        var self = this;
        var id =  self.$route.params.id;
        if (flag == 'edit'){

            self.$router.push("/rentalagreement/edit/"+id);

        }
        if (flag == 'policy'){

            self.$router.push("/rentalagreement/edit/"+id+'?from=policy');

        }

        if (flag == 'return'){
            if (self.status == 'pending'){
                self.$swal('','Please process agreement first','info');
                return;
            }

            self.$router.push("/rentalagreement/edit/"+id+'?from=return');

        }

    },
    viewBooking:function(id){
        var self = this;
        let routeData = self.$router.resolve({ name:"ReservationContent",params:{ id: id}});
        window.open(routeData.href,"_blank");
    },
    rebillVariable:function(){
        var self = this;

        self.fetchBilledVariableRates();
    },
    fetchBilledVariableRates:function(){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/billed-variable",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                id: segments[3],
                flag: "agreement"
            },
            success: function (data) {

                self.loading = false;

                if (data.status == "success") {

                    self.billedVariableArr = data.content;
                    self.activetab = 2;
                    self.rebill = true;
                }else{
                    self.billedVariableArr = [];
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    cancelRebill:function(){
        var self = this;

        self.rabill = false;
        self.billedVariableArr = [];

    },
    postRebill:function(){
        var self  = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        var error = false;
        var alertOccuured = false;
        if (self.billedVariableArr && self.billedVariableArr.length > 0){
            for (var i=0; i<self.billedVariableArr.length; i++) {
                if (self.billedVariableArr[i].new_reading == '' || self.billedVariableArr[i].new_reading == 0){
                    self.billedVariableArr[i].new_reading_error_msg = 'Reading Required';
                    error = true;
                }else{
                    self.billedVariableArr[i].new_reading_error_msg = '';
                }
                if (parseInt(self.billedVariableArr[i].new_reading) < parseInt(self.billedVariableArr[i].reading_in)){
                    if (alertOccuured == false){
                        if (confirm('New Reading in less than previous reading')) {
                            alertOccuured = true;
                        }else{
                            error = true;
                        }
                    }
                }
                for (var j=0; j<self.unitArr.length; j++){
                    if (self.unitArr[j].sectionName.toLowerCase().trim() == self.billedVariableArr[i].section.toLowerCase()){
                        if (self.billedVariableArr[i].new_reading != '' && parseInt(self.billedVariableArr[i].new_reading) <= parseInt(self.unitArr[j].reading_out)){
                            self.billedVariableArr[i].new_reading_error_msg = 'New Reading Should be greater than reading out.';
                            error = true;
                        }
                    }
                }
            }
        }else{
            self.$swal('','No invoice found for variable rates','info');
            return;
        }

        if (!error){

            $.ajax({
                url: process.env.ROOT_API + "/post-rebill",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    id: segments[3],
                    readingArr: JSON.stringify(self.billedVariableArr),
                    flag:'agreement'
                },
                success: function (data) {

                    self.loading = false;

                    if (data.status == "success") {
                        if (data.content.id){
                            self.$router.push('/rental-agreement/invoice/'+data.content.id);
                        }else{

                        }
                    }else{

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
        }

    },
    downloadPdf() {
        var self = this;
        var id =  self.$route.params.id;
        self.loading = true ;
        $.ajax({
            url: process.env.ROOT_API + "/rentalagreement/pdf",
            type: "POST",
            data: {
                id:id
            },
            headers: this.ajxHeaders,
            dataType: 'json',
            success: function (data) {
                self.loading = false ;
                var link = document.createElement('a');
                document.body.appendChild(link);
                link.href = data.content;
                link.download = '';
                link.target = "_blank";
                link.click();
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.error = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem('user_obj');
                        localStorage.removeItem('tkn');

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    openModal: function(flag){
        var self = this;
        if (flag == 'first'){
            self.forFirstInvoice = true;
        }else{
            self.bill_date = self.actual_to_date;
        }
        self.fetchBilling(flag);
        $("#postInvoiceModal").modal("show");
    },
    hideBillModal() {
        var self = this;
        self.forFirstInvoice = false;
        $("#postInvoiceModal").modal("hide");
        self.bill_date = '';
        self.bill_date_error = '';
    },
    hideDateModal:function(){
        var self = this;
        $("#check-date-modal").modal("hide");

        // self.actual_from_date = moment().format("MM/DD/YYYY");
        // self.actual_from_time = moment().format("hh:mm");
        // self.actual_from_ampm.value = moment().format('a');
        // self.actual_from_ampm.text = moment().format('A');
        self.actual_from_date = '';
        self.actual_from_time = '';
        self.actual_from_time_error_msg= '';
        self.actual_from_datetime_error_msg= '';
        self.actualFromTime= '';
        self.dateAdded ='false';
    },
    postInvoice() {
        var self = this;
        // var forecastId = self.$route.params.id;

        var path = window.location.pathname;
        var segments = path.split("/");
        var invoiceFor = 'last';
        if(!self.forFirstInvoice){
            self.bill_date_error = '';

            if (self.bill_date == '' || self.bill_date == null){
                self.bill_date_error = 'Bill Date Required';
                return;
            }

            if (self.bill_date != '' && new Date(self.bill_date) < new Date(self.actual_to_date)){//bill date should not be earlier than Actual In Date
                self.bill_date_error = 'Bill Date Should Not Be earlier than Actual In Date';
                return;
            }
        }else{
            invoiceFor = 'first';
        }
        if (self.postOnce == 1){
            return;
        }

        self.postOnce = 1;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/agreement-invoice/post",
            type: "POST",
            data: {
                agreement_id:segments[3],
                bill_date:self.bill_date,
                invoiceFor:invoiceFor
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                self.postOnce = 0;
                if (data.status == "success") {

                    if (data.content.id && data.content.id != undefined){
                        self.$router.push("/rental-agreement/invoice/"+data.content.id+'?from=agreement&ra='+segments[3]);
                    }

                    if (data.code == 201){

                        self.$swal('',data.message,'info');
                        self.bill_date = '';
                        self.bill_date_error = '';

                        $("#postInvoiceModal").modal("hide");

                    }else{
                        self.bill_date = '';
                        self.bill_date_error = '';
                        $("#postInvoiceModal").modal("hide");
                    }

                }else{

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.postOnce = 0;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    closeAgreement:function(){
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/agreement/close",
            type: "POST",
            data: {
                agreement_id:segments[3],
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {

                    // if (data.content.id){
                    //     self.$router.push("/rentalagreement/view/"+segments[3]);
                    // }

                    if (data.code == 201){

                        self.$swal('',data.message,'info');
                        self.bill_date = '';
                        self.bill_date_error = '';
                        self.loadRentalAgreement();
                        $("#postInvoiceModal").modal("hide");

                    }else{
                        self.bill_date = '';
                        self.bill_date_error = '';
                        self.loadRentalAgreement();
                        $("#postInvoiceModal").modal("hide");
                    }

                }else{

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });

    },
    billingRecords() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/billing-records",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                id: segments[3],
                flag: "agreement"
            },
            success: function (data) {

                self.loading = false;

                if (data.status == "success") {

                    self.billingRecordsArr = data.content;
                }else{
                    self.billingRecordsArr = [];
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });

    },
    updateScopeRate() {
        var self = this;
        if (self.scopeRateFound == 1){
            self.$router.push("/scoperate/edit/"+self.scopeRateId+"?from=agreement");
        }else{
            self.$router.push("/scoperate/edit/"+self.$route.params.id+"?from=agreement_no_rate");
        }
    },
    numberFormat(amount) {
        const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits:2,
            maximumFractionDigits:2
        });

        return formatter.format(amount);
    },
    backChargeList() {
        var self = this;
        self.updateCharge = false;
        self.rows = [];
    },
    editCharges() {
        var self = this;
        self.updateCharge = true;
        self.rows = [];
        for (var i = 0;i < self.insuranceChargesArr.length;i++) {
            console.log(self.insuranceChargesArr[i]);
            if (self.insuranceChargesArr[i] != undefined) {
                if (self.insuranceChargesArr[i].physical_ins_charges != undefined) {
                    self.rows.push({
                        charge_name:self.insuranceChargesArr[i].phy_charges_name,
                        charge_identifier:"physical_insurance_fee",
                        days:self.insuranceChargesArr[i].days,
                        rate:self.insuranceChargesArr[i].physical_ins_charges,
                        total:self.insuranceChargesArr[i].physical_ins_total,
                        type:self.insuranceChargesArr[i].phy_charges_type,
                        rate_error_msg:"",
                        charge_type:"physical",
                        charge_days:self.insuranceChargesArr[i].days,
                    });
                }
                if (self.insuranceChargesArr[i].physical_admin_charges != undefined) {
                    self.rows.push({
                        charge_name:self.insuranceChargesArr[i].phy_admincharges_name,
                        charge_identifier:"physical_admin_fee",
                        days:self.insuranceChargesArr[i].days,
                        rate:self.insuranceChargesArr[i].physical_admin_charges,
                        total:self.insuranceChargesArr[i].physical_admin_total,
                        type:self.insuranceChargesArr[i].phy_admin_type,
                        rate_error_msg:"",
                        charge_type:"physical",
                        charge_days:"-",
                    });
                }
                if (self.insuranceChargesArr[i].liability_insurance_charges != undefined) {
                    self.rows.push({
                        charge_name:self.insuranceChargesArr[i].lia_insurance_name,
                        charge_identifier:"liability_insurance_fee",
                        days:self.insuranceChargesArr[i].days,
                        rate:self.insuranceChargesArr[i].liability_insurance_charges,
                        total:self.insuranceChargesArr[i].liability_insurance_total,
                        type:self.insuranceChargesArr[i].lia_insurance_type,
                        rate_error_msg:"",
                        charge_type:"liability",
                        charge_days:self.insuranceChargesArr[i].days,
                    });
                }
                if (self.insuranceChargesArr[i].liability_admin_charges != undefined) {
                    self.rows.push({
                        charge_name:self.insuranceChargesArr[i].lia_admincharges_name,
                        charge_identifier:"liability_admin_fee",
                        days:self.insuranceChargesArr[i].days,
                        rate:self.insuranceChargesArr[i].liability_admin_charges,
                        total:self.insuranceChargesArr[i].liability_admin_total,
                        type:self.insuranceChargesArr[i].lia_admin_type,
                        rate_error_msg:"",
                        charge_type:"liability",
                        charge_days:"-",
                    });
                }
            }
        }
        console.log(self.rows);
    },
    calculateChargeTotal($event,index) {
        var self = this;
        if (self.rows[index] != undefined) {
            if (self.rows[index].charge_days != "-") {
                self.rows[index].total = self.rows[index].days * self.rows[index].rate;
            }else{
                self.rows[index].total = self.rows[index].rate;
            }
        }
    },
    goToVoucher:function(id){
        var self = this;

        // v-bind:to="{name: 'BillView',params:{id:record.id}}"

        self.$router.push("/vendor-invoice/view/"+id+'?from=agreement&&ref='+self.$route.params.id);
    },
    updateCharges() {
        var self = this;
        var error = false;
        for (var i=0;i<self.rows.length;i++) {

            self.rows[i].rate_error_msg = "";

            if (self.rows[i].rate == "" || !self.rows[i].rate) {
                self.rows[i].rate_error_msg = "Charge Required.";
                error = true;
            }
        }
        if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");

            $("#CreateChargeBtn").val("Updating ...");
            $("#CreateChargeBtn").prop("disabled", true);
            $("#CancelChargeBtn").prop("disabled",true);

            var fields = $("#chargeForm").serializeArray();
            fields.push({name: "chargeItems", value: JSON.stringify(self.rows)});
            fields.push({ name: "id", value: segments[3] });

            $.ajax({
                url: process.env.ROOT_API + "/agreement-charge/update",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    $("#CreateChargeBtn").val("Update");
                    $("#CreateChargeBtn").prop("disabled", false);
                    $("#CancelChargeBtn").prop("disabled",false);

                    if (data.status == "success") {

                        self.updateCharge = false;
                        self.loadRentalAgreement();
                        self.$root.$emit('activity_log_opted','rental agreement',segments[3]);//refresh activity log

                    } else {

                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    $("#CreateChargeBtn").val("Update");
                    $("#CreateChargeBtn").prop("disabled", false);
                    $("#CancelChargeBtn").prop("disabled",false);
                    self.generateStatusCodeMessage(jqXHR,false,'update-agreement-charge')
                }
            });
        }
    },
    getActivityLog(){
      var self = this;
      self.activetab = 6;
      var path = window.location.pathname;
      var segments = path.split("/");
      if(!self.tabMenuArray.includes(self.activetab)){
        //self.tabMenuArray.push(self.activetab);
        // setTimeout(function(){

        this.$root.$emit('activity_log_opted','rental agreement',segments[3]);

        // },500);
        self.activityLogsTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.
      }
    },
    fetchBilling:function(from){
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");
        // self.activetab = 7;
        // if (self.billingLoaded){
        //     return;
        // }
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/return-billing/fetch",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                id: segments[3],
                flag: "agreement",
                inv_for:from
            },
            success: function (data) {

                self.loading = false;
                self.billingLoaded = true;

                if (data.status == "success") {
                    self.amount = false;
                    self.billingArr = data.content;

                    if (self.billingArr.length > 0){
                        for (var i=0;i<self.billingArr.length;i++){
                            if (self.billingArr[i].billed_days != 0){
                                self.amount = true;
                            }
                        }
                    }
                }else{
                    self.billingArr = [];
                    self.amount = false;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    checkTriggers:function(flag){
        var self = this;
        // var dateAdded = false;
        var error = false;
        if (flag == 'check_date'){
            if (self.actualOutDateTime == '' || self.actualOutDateTime == null || self.actualOutDateTime == undefined){
                $("#check-date-modal").modal("show");
                self.actual_from_date = moment().format("MM/DD/YYYY");
                self.actual_from_time = moment().format("hh:mm");
                self.actual_from_ampm.value = moment().format('a');
                self.actual_from_ampm.text = moment().format('A');
                return;
            }else{

            }
        }
        if (flag == 'validate'){

            self.actual_from_datetime_error_msg = '';
            self.actual_from_time_error_msg = '';
            if (!self.actual_from_date || self.actual_from_date == null || self.actual_from_date == "") {
                self.actual_from_datetime_error_msg = "Actual from Date require.";
                error = true;
            }

            if (self.actual_from_time == null || self.actual_from_time == "") {
                self.actual_from_time_error_msg = "Actual from Time Required.";
                error = true;
            } else {

                if ( self.actual_from_time.includes("_") ) {
                    self.actual_from_time_error_msg = "Please check Actual from time format.";
                    error = true;
                }
            }
            if (self.actual_from_time.includes("_") == false && self.actual_from_time != '' && (self.actual_from_ampm != null ) && self.actual_from_ampm.value){
                self.actualFromTime = self.changeTime12To24Hrs(self.actual_from_time+" "+ self.actual_from_ampm.value);
            }else{
                self.actualFromTime = '';

            }
            if (self.actualInDateTime && (new Date(self.actual_from_date+' '+self.actualFromTime) > new Date(self.actualInDateTime))){
                // self.$swal('','Actual In Date should not be earlier than Actual Out Date','info');
                self.actual_from_datetime_error_msg = 'Actual From Date should not be greater than Actual In Date';
                error = true;
            }
            if (self.dueInDateTime && (new Date(self.actual_from_date+' '+self.actualFromTime) > new Date(self.dueInDateTime))){
                // self.$swal('','Due In Date should not be earlier than Actual Out Date','info');
                self.actual_from_datetime_error_msg = 'Actual From Date should not be greater than Due In Date';
                error = true;
            }
            var now = new Date();
            if (self.actual_from_date && (new Date(self.actual_from_date+' '+self.actual_from_time+' '+self.actual_from_ampm.value) > new Date(moment(now).format('MMM/DD/YYYY hh:mm A')))){
                //   self.$swal('',"Actual From Date Should Not Be Later Than Current Date",'info');
                //   return;
                // self.actual_from_datetime_error_msg = 'Actual From Date Should Not Be Later Than Current Date';
                // error = true;
            }

            if (error){
                return;
            }
            // self.actualFromTime = actualFromTime;

            self.dateAdded = 'true';
            $("#check-date-modal").modal("hide");
        }

        // if (flag == 'process'){
        //     if (self.actualOutDateTime == null || self.actualOutDateTime == ''){
        //         self.$swal('','Please update actual out date time','info');
        //         return;
        //     }
        // }

        if (flag == 'no_action'){
            $("#trigger-message-modal").modal("hide");
            return;
        }
        if (flag != 'no_program'){
            var miles = 0;
            var date = self.actualOutDate;
            if (self.unitArr && self.unitArr.length > 0){
                for (var i=0; i<self.unitArr.length; i++) {
                    if (self.unitArr[i].section && self.unitArr[i].section == 'DIST'){
                        miles = self.unitArr[i].reading_out;
                        date = self.unitArr[i].reading_out_date;
                    }
                }
            }
            self.$refs.triggerEnable.getMappedProgram(self.vehicle_id,miles,date);

            return;
        }else{
            $("#trigger-message-modal").modal("hide");
            self.processAgreement('process','');
        }
    },
    processAgreement: function(flag,is_force){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");


        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/rental-agreement/process",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                id: segments[3],
                flag:flag,
                force_process:is_force,
                actual_date:self.actual_from_date,
                actual_time:self.actualFromTime,
                dateAdded:self.dateAdded
            },
            success: function (data) {

                self.loading = false;
                self.billingLoaded = true;
                if (data.code == 201 && flag == 'process' ) {
                    if(data.message.includes("Rate not approved yet")) {
                        self.$swal('',data.message,'info');
                        self.loadRentalAgreement();
                        return;
                    }

                    if(data.message.includes("Asset Already Reserved with")) {
                        self.$swal('',data.message,'info');
                        self.loadRentalAgreement();
                        return;
                    }

                    if ( data.creditStatus == "sent" || data.creditStatus == "denied" ) {
                        self.$swal('',data.message,'info');
                        return;
                    }

                    if ( data.message.includes("Sufficient credit not found. Please contact the AR team") || data.message.includes("Customer's credit is not approved")) {

                        self.$swal({
                            title: '',
                            html: 'Customer credit is not approved yet or insufficient credit found. Do you want to send credit override request?',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            showCloseButton: false,
                            showLoaderOnConfirm: true
                        }).then((result) => {
                            if (result.value) {
                                self.sendForApproval('credit_override');
                            } else {
                                console.log("no");
                            }
                        });
                        return;
                    }

                    // self.$swal('',data.message,'info');
                    self.$swal({
                        title: '',
                        html: data.message,
                        type: 'info',
                        showCancelButton: false,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        showCloseButton: false,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {

                            if(data.message.includes("Insurance Policy Not Added.")) {
                            } else {
                                if ( process.env.APP_ENV != 'production' ) {
                                    self.processAgreement('process','true');
                                }
                            }

                        }
                    });


                } else if (data.code == 201 && flag == 'unprocess'){
                    self.$swal('',data.message,'info');
                    return;
                }
                if (data.status == "success") {
                    if (flag == 'unprocess'){
                        self.$swal('','Agreement UnProcessed','info');
                    }else{
                        self.$swal('','Agreement Processed','info');
                    }
                    self.loadRentalAgreement();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    sendForApproval:function(flag){
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");
        self.loading = true;

        $.ajax({
        url: process.env.ROOT_API + "/user/send-notification",
        type: "POST",
        headers: this.ajxHeaders,
        dataType: "json",
        data:{
            moduleId: segments[3],
            status: 'sent',
            customerId:self.customerId,
            module:'rental_agreement',
            flag:flag
        },
        success: function (data) {
            self.loading = false;
                if (data.status == "success") {
                    if (flag == 'deposit'){
                        self.$swal('','Refund Request sent','success');
                    }else{
                        self.exDate = '';
                        self.$swal('','Credit Override sent for approval','success');
                    }

                    self.loadRentalAgreement();
                } else {
                    self.$swal('',data.message,'error');
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    discountedDayGenerate:function(){
        var path = window.location.pathname;
        var segments = path.split("/");
        this.$swal({
                title: "Discounted Days",
                text: "Want to Generate Discouted Days ?",
                type: "info",
                // inputOptions:[{text:'reason',value:'reservation ended'}],
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "Close",
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then(result => {

                if (result.value) {
                    self.loading = true;

                    $.ajax({
                    url: process.env.ROOT_API + "/discounted-days/create",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        moduleId: segments[3],
                    },
                    success: function (data) {
                        self.loading = false;
                            if (data.status == "success") {
                                self.loadRentalAgreement();
                            } else {
                                self.$swal('',data.message,'error');
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                } else if (result.dismiss) {
                    // self.$router.push("/./listbookings");
                }
            });

    },
    approveRates:function(flag){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        if (flag == 'reject'){
            this.$swal({
                title: "Are you sure?",
                text: "Reason for Reject",
                type: "warning",
                input: "textarea",
                // inputOptions:[{text:'reason',value:'reservation ended'}],
                showCancelButton: true,
                confirmButtonText: "Confirm",
                cancelButtonText: "Close",
                showCloseButton: true,
                showLoaderOnConfirm: true,
                preConfirm: function (value) {
                    // alert($("#swal-input1").val());
                    // var val = true;
                    return new Promise(function (resolve, reject) {
                    if(value == 0 && $(".swal2-textarea").val() == ''){
                        self.$swal.showValidationError(
                            'Please Enter Reason.'
                        )
                        value = false;
                    }

                    resolve(value)
                    })
                }
            }).then(result => {

                if (result.value) {

                    //getting comment value for reason of cancellation
                    var comment = result.value;
                    self.rateApprove('reject',comment);

                } else if (result.dismiss) {
                    // self.$router.push("/./listbookings");
                }
                console.log(result);
            });
        }else{
            this.$swal({
                title: "Are you sure?",
                text: "Approve Rates",
                type: "warning",
                // inputOptions:[{text:'reason',value:'reservation ended'}],
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "Close",
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then(result => {

                if (result.value) {
                    self.rateApprove('approve','');
                } else if (result.dismiss) {
                    // self.$router.push("/./listbookings");
                }
            });
        }


    },
    rateApprove:function(flag,reason){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/rental-agreement-rates/approve",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                id: segments[3],
                flag:flag,
                reason:reason,
                ex_date:self.exDate,
                first_time:self.existRequired,
                contractTypeId:self.contractTypeId,
                customerId:self.customerId
            },
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.exDate = '';
                    if (flag == 'approve'){
                        self.$swal('','Rates Approved Successfully','success');
                    }else{
                        self.$swal('','Rates Rejected Successfully','success');
                    }
                    self.loadRentalAgreement();
                }else if(data.status == 'exist'){
                    const el = document.createElement('div')
                    el.innerHTML = "Rates are already exist to view rate <a href=/scope-rate/view/"+data.content+"?from=view&ag="+segments[3] +" "+"target=_blank style=color:blue>Click Here</a>"+" do you want override"
// console.log(el);
                    self.$swal({
                        title: "Are you sure?",
                        html: el.innerHTML,
                        type: "warning",
                        // inputOptions:[{text:'reason',value:'reservation ended'}],
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "Close",
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then(result => {

                        if (result.value) {
                            // self.rateApprove('approve','');
                            self.existRequired = 'false';
                            self.rateApprove('approve','');
                        } else if (result.dismiss) {
                            // self.$router.push("/./listbookings");
                        }
                    });
                }

                self.$refs.creditForm.getCustomerCreditRequest();
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    extendAgreement:function(){
        var self = this;

        $("#check-due-date-modal").modal("show");

        self.due_in_date = self.dueInDate;
        self.due_in_time = self.dueInTime;
        // self.due_in_ampm.value = moment().format('a');
        // self.due_in_ampm.text = moment().format('A');

        // self.due_in_date = '';
        // self.due_in_time = '';
        self.due_in_time_error_msg= '';
        self.due_in_datetime_error_msg= '';
        self.dueInTime= '';
        // self.dateAdded ='false';
    },
    hideDueInModal:function(){
        $("#check-due-date-modal").modal("hide");
    },
    updateDueOut:function(){
        var self = this;

        self.due_in_datetime_error_msg = '';
        self.due_in_time_error_msg = '';
        var error = false;
        if (!self.due_in_date || self.due_in_date == null || self.due_in_date == "") {
            self.due_in_datetime_error_msg = "Due from Date require.";
            error = true;
        }

        if (self.due_in_time == null || self.due_in_time == "") {
            self.due_in_time_error_msg = "Due In Time Required.";
            error = true;
        } else {

            if ( self.due_in_time.includes("_") ) {
                self.due_in_time_error_msg = "Please check Due In time format.";
                error = true;
            }
        }
        if (self.due_in_time.includes("_") == false && self.due_in_time != '' && (self.due_in_ampm != null ) && self.due_in_ampm.value){
            self.dueInTime = self.changeTime12To24Hrs(self.due_in_time+" "+ self.due_in_ampm.value);
        }else{
            self.dueInTime = '';
        }
        if (self.dueOutDateTime && (new Date(self.due_in_date+' '+self.dueInTime) < new Date(self.dueOutDateTime))){
            self.due_in_datetime_error_msg = 'Due In Date should not be greater than Due Out Date';
            error = true;
        }
        if (self.dueInDateTime && (new Date(self.due_in_date+' '+self.dueInTime) < new Date(self.dueInDateTime))){
            self.due_in_datetime_error_msg = 'Due In Date should not be less than Existing Due In Date';
            error = true;
        }

        if (error){
            return;
        }

        var path = window.location.pathname;
        var segments = path.split("/");
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/due-in-date/change",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                id: segments[3],
                due_in_date:self.due_in_date,
                due_in_time:self.dueInTime,
            },
            success: function (data) {
                self.loading = false;
                $("#check-due-date-modal").modal("hide");
                if (data.status == "success") {
                    self.loadRentalAgreement();
                }else{

                }
            },
            error: function (jqXHR, exception) {
                $("#check-due-date-modal").modal("hide");
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },

    getCustomerCreditRequest(){
        //console.log("checke the flow");
        var self = this;
        self.activetab = 11;
        self.enableCustomerCreditRequest = true;
        // if(!self.tabMenuArray.includes(self.activetab)){
            self.tabMenuArray.push(self.activetab);
        // }
    },

    setDefaultRate:function(){
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/rate-to-default/change",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                id: segments[3],
            },
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.loadRentalAgreement();
                }else{

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });

    },
    viewModulelink(url,id,from) {
            let self = this;
            let link = url+id;
            if(from!=""){
                link += from;
            }
            let routeData = self.$router.resolve(link);
            window.open(routeData.href, '_blank');
    }
  }
};
</script>
<style scoped>
    .adjustTitleWidth{
        width: 40% !important;
    }
    .widthCustom{
        width: 55% !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/rentalAgreement/RentalAgreementView.vue